import { Tier } from '@mc/api'

import { INDIVIDUAL } from '../constants'
import { getSpecificTierPropertiesAsync } from './getSpecificTierPropertiesAsync'
import { ProductsQueryParams } from './getTiersAsync'

let defaultTier: Tier

export const getDefaultTierAsync = async (
  refresh = false,
  params: ProductsQueryParams = {},
) => {
  if (!!defaultTier && !refresh) {
    return Promise.resolve(defaultTier)
  }

  defaultTier = await getSpecificTierPropertiesAsync(
    INDIVIDUAL,
    refresh,
    params,
  )

  return defaultTier
}
